import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const initialUsers = [
  { id: 1, username: 'admin', email: 'admin@payroll.com', role: 'ADMIN' },
  { id: 2, username: 'johndoe', email: 'john@payroll.com', role: 'EMPLOYEE' },
];

export const fetchUsers = createAsyncThunk('users/fetchUsers', async (_, { rejectWithValue }) => {
  await delay(500);
  return initialUsers;
});

export const addUser = createAsyncThunk('users/addUser', async (userData, { rejectWithValue }) => {
  await delay(500);
  const newUser = {
    ...userData,
    id: Math.floor(Math.random() * 10000)
  };
  return newUser;
});

const userSlice = createSlice({
  name: 'users',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        // Only set list if it's currently empty to preserve locally added users
        if (state.list.length === 0) {
          state.list = action.payload;
        }
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.list.push(action.payload);
      });
  },
});

export default userSlice.reducer;
